// Build My Routine product data loading.
// Loaded after classification/scoring and before build-my-routine.js.

async function parseProducts(productsDataScript) {
  const currentUrl = new URL(window.__bmrProductDataBaseUrl || window.location.href, window.location.origin);

  async function loadProductsForPage(pageNumber) {
    const pageUrl = new URL(currentUrl.href);
    pageUrl.searchParams.set('page', String(pageNumber));

    const response = await fetch(pageUrl.toString(), {
      headers: {
        Accept: 'text/html'
      }
    });

    if (!response.ok) {
      return [];
    }

    const html = await response.text();
    const parser = new DOMParser();
    const document = parser.parseFromString(html, 'text/html');
    const script = document.getElementById('build-my-routine-products-data');
    const payload = safeJsonParse(script ? script.textContent : '[]', []);

    if (Array.isArray(payload)) {
      return payload;
    }

    return Array.isArray(payload.products) ? payload.products : [];
  }

const parsed = safeJsonParse(productsDataScript ? productsDataScript.textContent : '[]', []);
const products = Array.isArray(parsed)
  ? [...parsed]
  : [...(Array.isArray(parsed.products) ? parsed.products : [])];

const totalPages = Array.isArray(parsed)
  ? 1
  : Math.max(1, Number(parsed.totalPages || 1));

const seenHandles = new Set(products.map((product) => product.handle).filter(Boolean));

for (let page = 2; page <= totalPages; page += 1) {
    const nextProducts = await loadProductsForPage(page);

    if (!nextProducts.length) break;

    nextProducts.forEach((product) => {
      if (!product || !product.handle || seenHandles.has(product.handle)) return;

      seenHandles.add(product.handle);
      products.push(product);
    });

    if (nextProducts.length < 250) break;
  }

  console.log('[BuildMyRoutine] products loaded:', products.length);

  return products.map((product) => {
    const normalized = {
      id: product.id,
      handle: product.handle,
      title: cleanLabel(product.title),
      vendor: cleanLabel(product.vendor),
      type: cleanLabel(product.type),
      product_type_meta: cleanLabel(product.product_type_meta),

      routine_family_id: normalizeValue(product.routine_family_id),
      routine_option_label: cleanLabel(product.routine_option_label),

      tags: toArray(product.tags).map((t) => String(t).trim()).filter(Boolean),
      url: cleanLabel(product.url),
      image: cleanLabel(product.image),
      available: Boolean(product.available),
      price_cents: Number(product.price_cents || 0),

      main_concern_label: cleanLabel(product.main_concern),
      main_concern: normalizeValue(product.main_concern),

      secondary_concern_labels: splitListValues(product.secondary_concerns).map(cleanLabel).filter(Boolean),
      secondary_concerns: splitListValues(product.secondary_concerns).map(normalizeValue).filter(Boolean),

      skin_profile_labels: splitListValues(product.skin_profile).map(cleanLabel).filter(Boolean),
      skin_profile: splitListValues(product.skin_profile).map(normalizeValue).filter(Boolean),

      skin_sensitivity_labels: splitListValues(product.skin_sensitivity).map(cleanLabel).filter(Boolean),
      skin_sensitivity: splitListValues(product.skin_sensitivity).map(normalizeValue).filter(Boolean),

      fitzpatrick_labels: splitListValues(product.fitzpatrick_type).map(cleanLabel).filter(Boolean),
      fitzpatrick: splitListValues(product.fitzpatrick_type).map(fitzLabelToNumber).filter(Boolean),

      age_category_labels: splitListValues(product.age_category).map(cleanLabel).filter(Boolean),

      routine_preference_label: cleanLabel(product.routine_preference),
      routine_preference: normalizeValue(product.routine_preference),

      active_ingredient_labels: splitListValues(product.active_ingredients).map(cleanLabel).filter(Boolean),
      active_ingredients: splitListValues(product.active_ingredients).map(normalizeValue).filter(Boolean),

      not_safe_to_layer_with_labels: splitListValues(product.not_safe_to_layer_with).map(cleanLabel).filter(Boolean),
      not_safe_to_layer_with: splitListValues(product.not_safe_to_layer_with).map(normalizeValue).filter(Boolean),

      allergies_labels: splitListValues(product.allergies).map(cleanLabel).filter(Boolean),
      allergies: splitListValues(product.allergies).map(normalizeValue).filter(Boolean),
      aesthetic_treatments: splitListValues(product.aesthetic_treatments).map(normalizeValue).filter(Boolean),

      topical_steroid_safe: normalizeValue(product.topical_steroid_use) === 'true',
      recent_isotretinoin_safe: normalizeValue(product.recent_isotretinoin) === 'true'
    };

    normalized.vendor_slug = normalizeValue(normalized.vendor);
    normalized.slot = classifyProductSlot(normalized);
    normalized.makeup_category = classifyMakeupCategory(normalized);

    return normalized;
  });
}

console.log('[BuildMyRoutine] data loaded');